/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation
import TailwindIcon from "./download.svg";
// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Butt poster",
  title: "Hi all, I'm Hassan",
  subTitle: emoji(
    "A passionate Full Stack Software Developer 🚀 having an experience of building Web and Mobile applications with JavaScript / Reactjs / Nodejs / React Native and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1ofFdKF_mqscH8WvXkSObnVvC9kK7Ldlu/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/Hassanbutt1103",
  linkedin: "www.linkedin.com/in/hassan-butt-a4a821241",
  gmail: "1103butt@gmail.com",
  gitlab: "https://gitlab.com/1103butt",
  facebook: "https://www.facebook.com/profile.php?id=100069303097534",
  medium: "https://medium.com/@1103butt",
  stackoverflow: "https://stackoverflow.com/users/29645495/hassan-butt",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
   {
  skillName: "tailwindcss",
  icon: TailwindIcon
},
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "ReactNative",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
  schoolName: "NCBA&E University",
  logo: require("./assets/images/OIP.webp"),
  subHeader: "Bachelor of Science in Computer Science",
  duration: "2024 - 2026",
  desc: "I will complete my Bachelor’s degree in 2026.",
  descBullets: [
    "Studying core subjects of Computer Science including Algorithms, Databases, and AI Development.",
    "Gaining practical experience through projects using React, Node.js, and other modern technologies."
  ]
},
   {
  schoolName: "NCBA&E University",
  logo: require("./assets/images/OIP.webp"),
  subHeader: "ADP in Computer Science",
  duration: "2021 - 2023",
  desc: "I completed my ADP in Computer Science from 2021 to 2024.",
  descBullets: [
    "Studied core Computer Science subjects including Software Engineering, Web Security, and Operating Systems.",
    "Completed various projects and gained hands-on experience in software development."

  ]
}

  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
  role: "Bounty Hunter",
  company: "Replit",
  companylogo: require("./assets/images/OIP.png"),
  date: "Jun 2025 – Jul 2025",
  desc: "Worked as a bounty hunter on Replit and earned 400+ $ in two months.",
  descBullets: [
    "Completed multiple bounties and coding tasks efficiently.",
    "Gained practical experience in full-stack development."
  ]
},
{
  role: "Full-Stack Developer",
  company: "Upwork",
  companylogo: require("./assets/images/1_Ygq1Pus2ILj7mSbA2QauZA.png"),
  date: "Aug 2025 – Sep 2025",
  desc: "Worked on Upwork as a front-end developer and earned 300+ $.",
  descBullets: [
    "Handled client projects and delivered quality work within deadlines."
  ]
},
{
  role: "Full-Stack Developer",
  company: "Fiverr",
  companylogo: require("./assets/images/1656739257fiverr-logo-transparent.png"),
  date: "Oct 2025 – Oct 2025",
  desc: "Worked for 1 month on Fiverr and earned 80$.",
  descBullets: [
    "Gained freelance experience and learned client communication skills."
  ]
}

  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Small Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
  image: require("./assets/images/66C6A21D-6F66-4AC6-9B9A-061F30038C89.png"),
  projectName: "The TradeMarkEdge",
  projectDesc: "This was a Fiverr client project where I built a website for their agency under the name 'The TradeMarkEdge'.",
  footerLink: [
    {
      name: "Visit Website",
      url: "http://thetrademarkedge.com/"
    }
  ]
},
    {
  image: require("./assets/images/470464612_1631690970759431_4013713585277944524_n.jpg"),
  projectName: "Nextu",
  projectDesc: "This was my own freelance company project which I started, but I haven't fully completed it yet.",
  footerLink: [
    {
      name: "Visit Website",
      url: "http://cntlcv.com"
    }
  ]
}

  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Some of my personal and freelance achievements in web development and projects.",

  achievementsCards: [
    {
      title: "Freelance Projects Completed",
      subtitle: "Completed multiple freelance projects on Fiverr, Upwork, and Replit.",
      image: require("./assets/images/sign-freelance-symbol-is-isolated-on-a-white-background-icon-color-editable-free-vector.jpg"), // Placeholder image
      imageAlt: "Freelance Logo",
      footerLink: [
        { name: "Fiverr Profile", url: "https://www.fiverr.com/s/8z8GaGV" },
        { name: "Upwork Profile", url: "https://www.upwork.com/freelancers/~01a79053a5e6e5ffb6?mp_source=share" }
      ]
    },
    {
      title: "React & Node.js Projects",
      subtitle: "Built several web apps using React, Node.js, Express, and MongoDB.",
      image: require("./assets/images/react-with-nodejs.png"), // Placeholder image
      imageAlt: "React Node Logo",
      footerLink: [
        { name: "View GitHub", url: "https://github.com/Hassanbutt1103" }
      ]
    },
    {
      title: "Personal Freelance Company",
      subtitle: "Started my own freelance company 'Nextu' and created a few initial projects.",
      image: require("./assets/images/470464612_1631690970759431_4013713585277944524_n.jpg"),
      imageAlt: "Nextu Logo",
      footerLink: [
        { name: "Visit Website", url: "http://cntlcv.com" }
      ]
    }
  ],
  display: true
};


// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Behind Every Brand, There’s a Story — Let’s Design Yours.",
      description:
        "There’s a story behind every successful business — and behind every great story is a design that makes people stop, notice, and remember."
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "How To grow your business",
      description:
        "To successfully run a business, you always need to hire a graphic designer who truly understands your brand and helps you stand out with attractive, impactful designs."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://docs.google.com/document/d/1LUFPOoxWysoi7Odfs-b7_6yqZ80RL3wxsavMsQECJ2g/edit?tab=t.0",
      event_url: "https://www.facebook.com/share/17aMjMb413/"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+92-3124527067",
  email_address: "1103butt@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
